var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-expand-data"},_vm._l((_vm.scope.row.fields),function(field,index){return _c('table-form-span',{key:index,attrs:{"formItems":_vm.formItems,"formVal":field,"initValue":false,"inline":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }